var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationProvider", {
    ref: "provider",
    attrs: {
      rules: { required: _vm.attachment.isRequired },
      mode: "aggressive",
      slim: ""
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var errors = ref.errors
          var failedRules = ref.failedRules
          return [
            _c(
              "td",
              {
                class: [_vm.getValidationErrorClasses(failedRules)].concat(
                  _vm.classes
                )
              },
              [
                _c("attachment-control", {
                  key: _vm.inputId,
                  attrs: {
                    inputId: _vm.inputId,
                    settings: _vm.attachmentSettings,
                    allowedExtensions: _vm.allowedExtensions,
                    required: _vm.attachment.isRequired,
                    "aria-invalid":
                      _vm.attachment.isRequired && errors.length > 0,
                    notifyonuploadedsuccess: _vm.notifyonuploadedsuccess
                  },
                  on: {
                    blur: _vm.blur,
                    "start-upload": function($event) {
                      return _vm.$emit("start-upload", $event)
                    },
                    "stop-upload": function($event) {
                      return _vm.$emit("stop-upload", $event)
                    },
                    "deleted-attachment": function($event) {
                      return _vm.$emit("deleted-attachment", $event)
                    },
                    "added-attachment": function($event) {
                      return _vm.$emit("added-attachment", $event)
                    }
                  },
                  model: {
                    value: _vm.attachment.fileNameWithExtension,
                    callback: function($$v) {
                      _vm.$set(_vm.attachment, "fileNameWithExtension", $$v)
                    },
                    expression: "attachment.fileNameWithExtension"
                  }
                }),
                _vm._v(" "),
                _vm.showErrorText && failedRules.required
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "text-lg-left text-md-center text-sm-center error-text"
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("Validation.FileIsMissing")))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }